/*
  Wishlist: the heart next to the product title, and the drawer opened by the
  header heart. Replaces the Notify Me wishlist.

  Guests: the list lives in this browser's localStorage, written only when the
  visitor clicks a heart (a service they asked for), never on page load.
  Logged-in customers: the list lives in the Helpdesk via the app proxy, so it
  follows them across devices; a guest list merges in on first login.
  Guest saves are also counted anonymously for the Helpdesk, but only when the
  visitor has accepted analytics.
*/
(function () {
  if (window.__boostWishlist) return;
  window.__boostWishlist = true;

  var cfg = window.BoostWishlist || {};
  var KEY = 'boost-wishlist';
  var loggedIn = !!cfg.customerId;
  var items = [];
  var productCache = {};

  function readLocal() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v : [];
    } catch (e) {
      return [];
    }
  }
  function writeLocal() {
    try {
      if (items.length) localStorage.setItem(KEY, JSON.stringify(items));
      else localStorage.removeItem(KEY);
    } catch (e) {}
  }
  function api(method, body) {
    return fetch(cfg.endpoint, {
      method: method,
      headers: body ? { 'Content-Type': 'application/json' } : {},
      body: body ? JSON.stringify(body) : undefined,
      credentials: 'same-origin'
    }).then(function (r) { return r.json(); });
  }
  function analyticsAllowed() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    try { return !!(cp && cp.analyticsProcessingAllowed()); } catch (e) { return false; }
  }

  function has(id) {
    return items.some(function (i) { return String(i.productId).split('/').pop() === String(id); });
  }
  function productFrom(el) {
    return { productId: el.dataset.productId, handle: el.dataset.productHandle, title: el.dataset.productTitle || '' };
  }

  function render() {
    document.querySelectorAll('[data-boost-wishlist-toggle]').forEach(function (btn) {
      var on = has(btn.dataset.productId);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', (on ? 'Remove ' : 'Save ') + (btn.dataset.productTitle || 'product') + (on ? ' from wishlist' : ' to wishlist'));
    });
    var header = document.getElementById('header-wishlist-button');
    if (header) {
      var badge = header.querySelector('.boost-wishlist-count');
      if (items.length) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'boost-wishlist-count';
          header.appendChild(badge);
        }
        badge.textContent = items.length > 99 ? '99+' : String(items.length);
      } else if (badge) {
        badge.remove();
      }
    }
    var count = document.querySelector('[data-boost-wishlist-title-count]');
    if (count) count.textContent = items.length ? ' (' + items.length + ')' : '';
    var drawer = document.querySelector('[data-boost-wishlist-drawer]');
    if (drawer && !drawer.hidden) renderDrawer();
  }

  function toggle(p) {
    var adding = !has(p.productId);
    if (adding) items.unshift(p);
    else items = items.filter(function (i) { return String(i.productId).split('/').pop() !== String(p.productId); });
    render();

    if (loggedIn) {
      api('POST', { op: adding ? 'add' : 'remove', productId: p.productId, handle: p.handle, title: p.title })
        .then(function (res) { if (res && res.items) { items = res.items; render(); } })
        .catch(function () {});
    } else {
      writeLocal();
      if (analyticsAllowed()) {
        api('POST', { op: 'event', action: adding ? 'add' : 'remove', productId: p.productId, handle: p.handle, title: p.title }).catch(function () {});
      }
    }
  }

  // Same format as the rest of the store (e.g. "€{{amount_with_comma_separator}}").
  function money(cents) {
    var fmt = cfg.moneyFormat || '€{{amount_with_comma_separator}}';
    function group(n, thousands, decimal, places) {
      var parts = (n / 100).toFixed(places).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_with_comma_separator': return group(cents, '.', ',', 2);
        case 'amount_no_decimals': return group(cents, ',', '.', 0);
        case 'amount_no_decimals_with_comma_separator': return group(cents, '.', ',', 0);
        case 'amount_with_apostrophe_separator': return group(cents, "'", '.', 2);
        default: return group(cents, ',', '.', 2);
      }
    }).replace(/<[^>]*>/g, '');
  }
  function loadProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return productCache[handle];
  }

  function renderDrawer() {
    var list = document.querySelector('[data-boost-wishlist-items]');
    if (!list) return;
    if (!items.length) {
      list.innerHTML = '<p class="boost-wishlist-empty">Your wishlist is empty. Tap the heart on any product to save it here.</p>';
      return;
    }
    list.innerHTML = '';
    items.forEach(function (it) {
      var row = document.createElement('div');
      row.className = 'boost-wishlist-item';
      row.innerHTML =
        '<img class="boost-wishlist-item__image" alt="" loading="lazy">' +
        '<div class="boost-wishlist-item__info"><p class="boost-wishlist-item__vendor"></p><a class="boost-wishlist-item__title"></a>' +
        '<div class="boost-wishlist-item__actions"><button type="button" class="boost-wishlist-item__add" disabled>Add to cart</button>' +
        '<button type="button" class="boost-wishlist-item__remove">Remove</button></div></div>' +
        '<div class="boost-wishlist-item__price"></div>';
      var link = row.querySelector('.boost-wishlist-item__title');
      link.textContent = it.title || it.handle;
      link.href = '/products/' + it.handle;
      row.querySelector('.boost-wishlist-item__remove').addEventListener('click', function () {
        toggle({ productId: it.productId, handle: it.handle, title: it.title });
      });
      list.appendChild(row);

      loadProduct(it.handle).then(function (prod) {
        if (!prod) {
          row.querySelector('.boost-wishlist-item__price').textContent = 'No longer available';
          return;
        }
        link.textContent = prod.title;
        row.querySelector('.boost-wishlist-item__vendor').textContent = prod.vendor || '';
        var img = row.querySelector('.boost-wishlist-item__image');
        if (prod.featured_image) img.src = (prod.featured_image.indexOf('//') === 0 ? 'https:' : '') + prod.featured_image + (prod.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=200';
        var variant = (prod.variants || []).find(function (v) { return v.available; });
        row.querySelector('.boost-wishlist-item__price').textContent = variant ? money(variant.price) : 'Sold out';
        var add = row.querySelector('.boost-wishlist-item__add');
        if (variant && (prod.variants || []).length === 1) {
          add.disabled = false;
          add.addEventListener('click', function () { addToCart(variant.id, add, it); });
        } else if (variant) {
          add.disabled = false;
          add.textContent = 'Choose options';
          add.addEventListener('click', function () { window.location.href = '/products/' + prod.handle; });
        } else {
          add.textContent = 'Sold out';
        }
      });
    });
  }

  function addToCart(variantId, btn, item) {
    btn.disabled = true;
    var cartDrawer = document.querySelector('cart-drawer');
    var sections = cartDrawer && cartDrawer.getSectionsToRender ? cartDrawer.getSectionsToRender().map(function (s) { return s.id; }) : [];
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }], sections: sections, sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        btn.disabled = false;
        if (res.status) return; // Shopify error payload (e.g. out of stock)
        if (item && analyticsAllowed()) {
          api('POST', { op: 'event', action: 'cart', productId: item.productId, handle: item.handle, title: item.title }).catch(function () {});
        }
        closeDrawer();
        if (cartDrawer && cartDrawer.renderContents) {
          // The drawer keeps its contents in a <template> until first opened;
          // unpack it first or renderContents has nothing to update.
          if (!cartDrawer.querySelector('.drawer__inner') && typeof window.loadTemplateContent === 'function') {
            window.loadTemplateContent(cartDrawer);
          }
          cartDrawer.classList.remove('is-empty');
          try {
            cartDrawer.renderContents(res);
          } catch (e) {
            window.location.href = '/cart';
          }
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(function () { btn.disabled = false; });
  }

  var closeTimer = null;
  function openDrawer() {
    var drawer = document.querySelector('[data-boost-wishlist-drawer]');
    if (!drawer) return;
    clearTimeout(closeTimer);
    drawer.hidden = false;
    document.body.style.overflow = 'hidden';
    renderDrawer();
    // Next frame, so the panel starts off-screen and slides in.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    });
    var close = drawer.querySelector('.boost-wishlist-drawer__close');
    if (close) close.focus({ preventScroll: true });
  }
  function closeDrawer() {
    var drawer = document.querySelector('[data-boost-wishlist-drawer]');
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    closeTimer = setTimeout(function () { drawer.hidden = true; }, 220);
  }

  document.addEventListener('click', function (e) {
    var heart = e.target.closest('[data-boost-wishlist-toggle]');
    if (heart) {
      e.preventDefault();
      toggle(productFrom(heart));
      return;
    }
    if (e.target.closest('#header-wishlist-button')) {
      e.preventDefault();
      openDrawer();
      return;
    }
    if (e.target.closest('[data-boost-wishlist-close]')) closeDrawer();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  function init() {
    var local = readLocal();
    if (!loggedIn) {
      items = local;
      render();
      return;
    }
    items = local;
    render();
    var sync = local.length ? api('POST', { op: 'merge', items: local }) : api('GET');
    sync
      .then(function (res) {
        if (res && res.ok && Array.isArray(res.items)) {
          items = res.items;
          if (local.length) {
            try { localStorage.removeItem(KEY); } catch (e) {}
          }
          render();
        }
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
